<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="指标编码" prop="factorCode">
                <el-input v-model="queryCondition.factorCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="指标名称" prop="factorName">
                <el-input v-model="queryCondition.factorName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="制成" prop="processId">
                <el-select v-model="queryCondition.processId" filterable>
                  <el-option :key="index" v-for="(item,index) in processList" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select table="TT_PROC" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="handleAdd" v-acl="PROC_FACTOR_MANAGE_MAINTAIN">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="handleBatchDelete" v-acl="PROC_FACTOR_MANAGE_MAINTAIN">批量删除</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="sortIndex" label="序号" :sort-method="(a,b) => sortMethods(a ,b , 'sortIndex')" width="60" />
          <el-table-column prop="factorCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'factorCode')" label="指标编码" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="factorName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'factorName')" label="指标名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="factorDesc" sortable :sort-method="(a,b) => sortMethods(a ,b , 'factorDesc')" label="指标描述" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="processName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'processName')" label="所属制成" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="inputMode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'inputMode')" label="输入模式" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="getIndicatorInputModeTag(scope.row.inputMode)">
                {{scope.row.inputModeText}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" sortable :sort-method="(a,b) => sortMethods(a ,b , 'status')" label="状态" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'danger'">
                {{ scope.row.statusText}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="创建人" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createDate" label="创建时间" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updateBy" label="更新人" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updateDate" label="更新时间" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" min-width="250" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleEdit(scope.row)" v-acl="PROC_FACTOR_MANAGE_MAINTAIN">编辑</el-button>
              <el-button type="primary" size="small" @click="handleManageParams(scope.row)" v-acl="PROC_FACTOR_MANAGE_MAINTAIN">参数管理</el-button>
              <el-button type="danger" size="small" @click="handleDelete(scope.row)" v-acl="PROC_FACTOR_MANAGE_MAINTAIN">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
      <!-- 新增/编辑指标 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false" @close="onClose" class="process_dialog" top="10px">
        <el-form ref="formData" :model="formData" :rules="formRules" label-width="90px" width="40%">
          <el-form-item label="指标编码" prop="factorCode">
            <el-input v-model="formData.factorCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="指标名称" prop="factorName">
            <el-input v-model="formData.factorName" placeholder="请输入指标名称" maxlength="50" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="指标描述" prop="factorDesc">
            <el-input v-model="formData.factorDesc" type="textarea" :rows="3" placeholder="请输入指标描述" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="所属制成" prop="processId">
            <el-select v-model="formData.processId" filterable :disabled="indicatorType!=='add'" style="width:100%">
              <el-option :key="index" v-for="(item,index) in processList1" :disabled="item.disabled" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="输入模式" prop="inputMode">
            <ic-select table="TT_PROC" field="INPUT_MODE" clearable v-model="formData.inputMode" :disabled="indicatorType!=='add'" style="width:100%"></ic-select>
          </el-form-item>
          <el-form-item label="指标处理器" prop="factorProcessor" v-if="formData.inputMode=='LIST'">
            <ic-select table="TT_PROC" field="FACTOR_PROCESSOR" clearable v-model="formData.factorProcessor" :disabled="indicatorType!=='add'" style="width:100%"></ic-select>
          </el-form-item>
          <el-form-item label="序号" prop="sortIndex">
            <el-input v-model="formData.sortIndex" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" :disabled="indicatorType!=='add'" placeholder="请输入序号"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <ic-select table="TT_PROC" field="STATUS" :disabled="indicatorType=='add'" clearable v-model="formData.status" style="width:100%"></ic-select>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onSave" :disabled="isSaveDisabled" :loading="isSaveLoading">确定</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose">取消</el-button>
        </el-row>
      </el-dialog>
      <!-- 参数管理 -->
      <el-dialog :title="paramDialogTitle" :visible.sync="paramDialogVisible" width="75%" :close-on-click-modal="false" @close="onCloseParam" class="process_dialog">
        <div class="param-management">
          <div class="param-header">
            <div class="header-left">
              <!-- <h3 class="indicator-title">{{ currentIndicator.factorName }}</h3> -->
              <span class="indicator-desc">{{ currentIndicator.factorDesc }}</span>
            </div>
            <div class="header-right">
              <el-button type="primary" icon="el-icon-plus" @click="handleAddParam" size="mini">新增参数</el-button>
            </div>
          </div>

          <div class="indicator-input-mode-config">
            <div class="config-section">
              <div class="section-header">
                <i class="el-icon-setting"></i>
                <span>指标输入模式配置</span>
                <el-tag :type="getIndicatorInputModeTag(currentIndicator.inputMode)" size="mini">
                  {{ currentIndicator.inputModeText}}
                </el-tag>
              </div>
              <div class="form-mode-info">
                <div :class="currentIndicator.inputMode === 'TABLE'?'matrix-confgi-section isPadding':'matrix-confgi-section'">
                  <div class="quick-config">
                    <p class="config-tip" v-if="currentIndicator.inputMode === 'TABLE'">配置多值维度列：</p>
                    <div class="quick-buttons">
                      <el-button type="primary" size="mini" @click="handleOpenMultiValuesDialog" v-if="currentIndicator.inputMode === 'TABLE'">配置多值维度</el-button>
                      <el-button type="success" size="mini" @click="handlePreviewMatrixMode" :disabled="multiForm.valueColumns.length === 0" icon="el-icon-view">预览数据录入界面</el-button>
                    </div>
                  </div>
                  <!-- <div class="preview-config" v-if="currentIndicator.inputMode === 'TABLE'">
                    <p class="preview-title">当前配置预览：</p>
                    <div v-if="multiForm.valueColumns.length > 0" class="preview-list">
                      <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto">
                        <li v-for="(col, index) in multiForm.valueColumns" :key="index" class="preview-item">
                          <i class="el-icon-check"></i>
                          <span class="col-name">{{ col.columnName }}</span>
                        </li>
                      </ul>

                    </div>
                    <div v-else class="preview-empty">
                      <i class="el-icon-info"></i>
                      <span>暂未配置多值维度，请点击"配置多值维度"按钮进行详细配置</span>
                    </div>
                  </div> -->
                </div>
              </div>

            </div>
            <div class="param-table">
              <el-table :data="paramTableData" max-height="425" border stripe style="width: 100%">
                <el-table-column prop="sortIndex" label="序号" width="60" />
                <el-table-column prop="paramCode" label="参数编码" width="120"></el-table-column>
                <el-table-column prop="paramName" label="参数名称" width="150"></el-table-column>
                <el-table-column prop="paramDesc" label="参数描述" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dataTypeText" label="数据类型" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="getDataTypeTag(scope.row.dataType)">
                      {{ scope.row.dataTypeText}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="required" label="是否必填" width="80">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.required ? 'success' : 'info'">
                      {{ scope.row.required ? '是' : '否' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="uom" label="单位" width="80"></el-table-column>
                <el-table-column prop="statusText" label="状态" width="80">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'danger'">
                      {{ scope.row.status === 'ACTIVE' ? '启用' : '禁用' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="200" align="center">
                  <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="handleEditParam(scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDeleteParam(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 参数新增/编辑弹窗 -->
      <el-dialog :visible.sync="paramFormVisible" :title="paramFormTitle" width="35%" append-to-body @close="handleParamFormClose">
        <el-form ref="paramFormRef" :model="paramFormData" :rules="paramFormRules" label-width="100px">
          <el-form-item label="参数编码" prop="paramCode">
            <el-input v-model="paramFormData.paramCode" disabled />
          </el-form-item>
          <el-form-item label="参数名称" prop="paramName">
            <el-input v-model="paramFormData.paramName" placeholder="请输入参数名称" maxlength="50" show-word-limit />
          </el-form-item>
          <el-form-item label="参数描述" prop="paramDesc">
            <el-input v-model="paramFormData.paramDesc" type="textarea" :rows="3" placeholder="请输入参数描述" maxlength="200" show-word-limit />
          </el-form-item>
          <el-form-item label="数据类型" prop="dataType">
            <ic-select table="TT_PROC" field="DATA_TYPE" clearable v-model="paramFormData.dataType" style="width:100%"></ic-select>
          </el-form-item>
          <el-form-item label="选择器类型" prop="selectorType" v-if="paramFormData.dataType=='SELECTOR'">
            <ic-select table="TT_PROC" field="SELECTOR_TYPE" clearable v-model="paramFormData.selectorType" style="width:100%"></ic-select>
          </el-form-item>
          <el-form-item label="字典" prop="selectorType" v-if="paramFormData.dataType=='DICT'">
            <el-input v-model="paramFormData.selectorType" placeholder="请输入字典"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="uom">
            <el-input v-model="paramFormData.uom" placeholder="请输入单位" />
          </el-form-item>
          <el-form-item label="是否必填" prop="required">
            <el-switch v-model="paramFormData.required" active-text="是" inactive-text="否" />
          </el-form-item>
          <el-form-item label="序号" prop="sortIndex">
            <el-input v-model="paramFormData.sortIndex" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" placeholder="请输入序号" />
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <ic-select table="TT_PROC" field="STATUS" :disabled="paramType=='add'" clearable v-model="paramFormData.status" style="width:100%"></ic-select>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="handleParamSubmit" :loading="paramSubmitLoading" :disabled="paramSubmitDisabled">确定</el-button>
          <el-button @click="handleParamFormClose">取消</el-button>
        </el-row>
      </el-dialog>
      <!-- 多值维度配置 -->
      <el-dialog title="多值维度配置" :visible.sync="multiValuesDialogVisible" width="60%" :close-on-click-modal="false" @close="onCloseMultiDialog" class="process_dialog">
        <div class="multi-values-container">
          <div class="columns-header">
            <h5>输入列配置</h5>
            <div class="header-actions">
              <el-button type="primary" size="small" @click="handleAddValueColumn" icon="el-icon-plus">添加列</el-button>
              <el-button type="success" size="small" @click="handleQuickAddRangeColumns" icon="el-icon-plus">快速添加范围列</el-button>
              <el-button type="warning" size="small" @click="handleClearAllColumns" v-if="multiForm.valueColumns.length > 0" icon="el-icon-delete">清空所有列</el-button>
            </div>
          </div>
          <el-form :model="multiForm" ref="multiForm">
            <el-table :data="multiForm.valueColumns" max-height="425" border stripe style="width: 100%">
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="columnName" label="列名称" min-width="200">
                <template slot-scope="scope">
                  <el-form-item :prop=" 'valueColumns.' + scope.$index + '.columnName' " :rules="columnNameRules(scope.$index, scope.row)">
                    <el-input v-model="scope.row.columnName" placeholder="如:每100克" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="columnDesc" label="描述" min-width="200">
                <template slot-scope="scope">
                  <el-form-item :prop=" 'valueColumns.' + scope.$index + '.columnDesc' ">
                    <el-input v-model="scope.row.columnName" placeholder="如:每100克" />
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="handleRemoveValueColumn(scope.row,scope.$index)" icon="el-icon-delete">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="handleSaveMultiValues" :disabled="isSaveMultiDisabled" :loading="isSaveMultiLoading">保存配置</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onCloseMultiDialog">取消</el-button>
        </el-row>
      </el-dialog>
      <!-- 快速添加范围列弹窗 -->
      <el-dialog :visible.sync="rangeColumnsDialogVisible" title="快速添加范围列" width="40%" class="process_dialog" @close="onCloseRangeConfigDialog">
        <div class="range-config-container">
          <div class="config-tip">
            <span>快速生成连续数字列,如:1、2、3、4...或者生产日期、小批次等</span>
          </div>
          <div class="quick-presets">
            <h5>常用预设：</h5>
            <div class="preset-buttons">
              <el-tag type="warning" @click="applyPreset('1-10')">1-10</el-tag>
              <el-tag type="warning" @click="applyPreset('1-20')">1-20</el-tag>
              <el-tag type="warning" @click="applyPreset('1-50')">1-50</el-tag>
              <el-tag type="warning" @click="applyPreset('1-100')">1-100</el-tag>
              <el-tag type="warning" @click="applyPreset('days')">生产日期(1-31天)</el-tag>
              <el-tag type="warning" @click="applyPreset('batches')">小批次(1-20批)</el-tag>
            </div>
          </div>

          <el-form :model="rangeConfig" label-width="100px">
            <el-form-item label="列名前缀">
              <el-input v-model="rangeConfig.prefix" placeholder="如：第、批次、日期" @input="setPreviewLists" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="起始数字">
              <el-input-number v-model="rangeConfig.startNumber" @change="numberChange" :min="1" :max="1000" style="width: 200px"></el-input-number>
            </el-form-item>
            <el-form-item label="结束数字">
              <el-input-number v-model="rangeConfig.endNumber" @change="numberChange" :min="1" :max="1000" style="width: 200px"></el-input-number>
            </el-form-item>
            <el-form-item label="列名后缀">
              <el-input v-model="rangeConfig.suffix" placeholder="如：天、次、批" @input="setPreviewLists" style="width: 200px"></el-input>
            </el-form-item>
          </el-form>

          <div class="preview-section">
            <h5>预览效果(显示前10列):</h5>
            <div class="preview-tags">
              <el-tag v-for="(preview, index) in rangePreview.slice(0, 10)" :key="index" type="primary" size="small" class="preview-tag">
                {{ preview }}
              </el-tag>
              <el-tag v-if="rangePreview.length > 10" type="info" size="small">
                ...还有{{ rangePreview.length - 10 }}列
              </el-tag>
            </div>
          </div>
        </div>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="handleConfirmAddRangeColumns">添加 {{ rangePreview.length }} 列</el-button>
          <el-button @click="onCloseRangeConfigDialog">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog :title="title" :visible.sync="previewDialogVisible" width="90%" class="process_dialog">
        <previewDialog :previewMultiLists="previewMultiLists" :previewColumns="previewColumns"></previewDialog>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import processApi from "@/api/Process/index";
import paginationMixin from '@/mixins/pagitionMixin';
import IcSelect from "@/components/common/icSelect";
import previewDialog from "./previewDialog.vue"
export default {
  name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect, previewDialog },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        factorCode: "",
        factorName: "",
        processId: "",
        status: "",
      },
      totalCount: 0,
      pages: 1,
      tableData: [],
      processList: [],
      processList1: [],
      dialogTitle: "",
      dialogVisible: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      paramDialogVisible: false,
      multiValuesDialogVisible: false,
      rangeColumnsDialogVisible: false,
      paramFormVisible: false,
      paramSubmitLoading: false,
      paramSubmitDisabled: false,
      isSaveMultiDisabled: false,
      isSaveMultiLoading: false,
      previewDialogVisible: false,
      paramDialogTitle: "",
      paramFormTitle: "",
      formData: {
        factorId: "",
        factorCode: "",
        factorName: "",
        factorDesc: "",
        processId: "",
        inputMode: "",
        sortIndex: "",
        factorProcessor: "",
        status: 'ACTIVE',
      },
      formRules: {
        factorName: [
          { required: true, message: "请输入指标名称", trigger: "blur" },
        ],
        processId: [{ required: true, message: "请选择所属制成", trigger: "change" }],
        inputMode: [{ required: true, message: "请选择输入模式", trigger: "change" }],
        sortIndex: [
          { required: true, message: "请输入序号", trigger: "blur" },
        ],
        factorProcessor: [{ required: true, message: "请选择输入模式", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      selectedRows: [],
      currentIndicator: {},
      paramTableData: [],
      multiForm: {
        valueColumns: [],
      },
      currentParam: {},
      rangeConfig: {
        prefix: "",
        startNumber: 1,
        endNumber: 10,
        suffix: "",
      },
      rangePreview: [],
      paramFormData: {
        paramCode: "",
        paramName: "",
        paramDesc: "",
        dataType: "",
        required: "",
        status: "",
        uom: "",
        sortIndex: "",
        paramId: "",
        factorId: "",
        selectorType: ""
      },
      paramFormRules: {
        paramName: [
          { required: true, message: "请输入参数名称", trigger: "blur" },
        ],
        dataType: [{ required: true, message: "请选择数据类型", trigger: "change" }],
        selectorType: [{ required: true, message: "请选择选择器类型", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        sortIndex: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { pattern: /^\d+$/, message: '只能输入整数', trigger: 'blur' }
        ],
      },
      factorId: "",
      indicatorType: "",
      paramType: "",
      rules: {},
      previewMultiLists: [],
      previewColumns: [],
      title: "",
      factorName: ""
    };
  },
  mounted() {
    this.queryData()
    this.getProcessIndicator()
  },
  methods: {
    queryData() {
      processApi.getProcessIndicatorFactor(this.queryCondition).then(res => {
        console.log("🚀 ~ queryData ~ res:", res)
        if (res.code == '200') {
          this.tableData = res.data.records
          this.totalCount = res.data.total
        }
      })
    },
    getProcessIndicator() {
      this.processList1 = []
      processApi.getProcessIndicator().then(res => {
        console.log("🚀 ~ getProcessIndicator ~ res:", res)
        res.data.forEach(ele => {
          this.processList.push({
            label: ele.processCode + '-' + ele.processName,
            value: ele.processId,
          })
          if (ele.status == 'ACTIVE') {
            this.processList1.push({
              label: ele.processCode + '-' + ele.processName,
              value: ele.processId,
            })
          } else {
            this.processList1.push({
              label: ele.processCode + '-' + ele.processName,
              value: ele.processId,
              disabled: true,
            })
          }

        })
      })
    },
    // 获取指标输入模式标签颜色
    getIndicatorInputModeTag(mode) {
      const tagMap = {
        SINGLE: "primary",
        LIST: "success",
        TABLE: "danger",
      }
      return tagMap[mode] || "";
    },
    handleAdd() {
      this.dialogTitle = "新增指标";
      this.indicatorType = 'add'
      this.formData = {
        factorId: "",
        factorCode: "",
        factorName: "",
        factorDesc: "",
        processId: "",
        inputMode: "",
        factorProcessor: "",
        sortIndex: "",
        status: 'ACTIVE',
      }
      this.dialogVisible = true;
    },
    onSave() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled = true
          this.isSaveLoading = true
          processApi.addOrUpdatefactor(this.formData).then(res => {
            if (res.code == '200') {
              this.$message.success('新增成功')
              this.onClose()
            }
            this.isSaveDisabled = false
            this.isSaveLoading = false
          })
        }
      })
    },
    onClose() {
      this.dialogTitle = "";
      this.indicatorType = ''
      this.formData.factorId = ""
      this.formData = {
        factorId: "",
        factorCode: "",
        factorName: "",
        factorDesc: "",
        processId: "",
        inputMode: "",
        factorProcessor: "",
        sortIndex: "",
        status: 'ACTIVE',
      }
      this.$refs['formData'].resetFields()
      this.dialogVisible = false;
      this.queryData();
    },
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      var factorIds = this.selectedRows.map(ele => ele.factorId)
      console.log("🚀 ~ onBatchDel ~ factorIds:", factorIds)
      this.$confirm(`确定要删除选中的 ${this.selectedRows.length} 条数据吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.batchDeleteFactor(factorIds).then(res => {
            console.log("🚀 ~ handleBatchDelete ~ res:", res)
            if (res.code == '200') {
              this.$message.success('删除成功')
              this.queryData()
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleEdit(row) {
      this.dialogTitle = "编辑指标";
      Object.assign(this.formData, row);
      this.indicatorType = 'edit'
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm(`确定要删除制成"${row.factorCode + '-' + row.factorName}"吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.deleteFactor(row.factorId).then(res => {
            if (res.code == '200') {
              this.$message.success('删除成功')
              this.queryData()
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleManageParams(row) {
      this.factorId = row.factorId
      this.factorName = row.factorName
      processApi.getParamLists(row.factorId).then(res => {
        console.log("🚀 ~ handleManageParams ~ res:", res)
        if (res.code == '200') {
          this.paramTableData = res.data
          this.paramDialogTitle = row.factorName ? row.factorName + ' - 参数管理' : '参数管理';
          this.currentIndicator = row;
          this.paramDialogVisible = true;
        }
      })
      processApi.getFactorColumn(this.factorId).then(res => {
        console.log("🚀 ~ handleManageParams ~ res111111:", res)
        if (res.code == '200') {
          this.multiForm.valueColumns = res.data
        }
      })
    },
    getParamLists(factorId) {
      processApi.getParamLists(factorId).then(res => {
        console.log("🚀 ~ handleManageParams ~ res:", res)
        if (res.code == '200') {
          this.paramTableData = res.data
        }
      })
    },
    onCloseParam() {
      this.factorId = ''
      this.currentIndicator = {}
      this.paramTableData = []
      this.paramDialogTitle = ""
      this.paramDialogVisible = false;
      this.queryData()
    },
    getDataTypeTag(dataType) {
      const tagMap = {
        NUMBER: "primary",
        TEXT: "success",
        TABLE: "danger",
      }
      return tagMap[dataType] || "";
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    // 新增/编辑参数
    handleAddParam() {
      this.paramFormTitle = "新增参数";
      this.paramType = 'add'
      Object.assign(this.paramFormData, {
        paramCode: "",
        paramName: "",
        paramDesc: "",
        dataType: "",
        required: false,
        status: "ACTIVE",
        uom: "",
        sortIndex: "",
        paramId: "",
        factorId: this.factorId
      });
      this.paramFormVisible = true;
    },
    handleEditParam(row) {
      this.paramFormTitle = "编辑参数";
      this.paramType = 'edit'
      Object.assign(this.paramFormData, row);
      this.paramFormVisible = true;
    },
    handleDeleteParam(row) {
      this.$confirm(`确定要删除参数"${row.paramCode + '-' + row.paramName}"吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.deleteParam(row.paramId).then(res => {
            if (res.code == '200') {
              this.$message.success('删除成功')
              this.getParamLists(this.factorId)
            }
          })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    handleParamSubmit() {
      this.$refs['paramFormRef'].validate((valid) => {
        if (valid) {
          this.paramSubmitLoading = true
          this.paramSubmitDisabled = true
          processApi.addOrUpdateFactorParam(this.paramFormData).then(res => {
            if (res.code == '200') {
              this.$message.success('新增成功')
              this.handleParamFormClose()
            }
            this.paramSubmitLoading = false
            this.paramSubmitDisabled = false
          })
        }
      })
    },
    handleParamFormClose() {
      this.paramFormTitle = "";
      this.paramType = ''
      this.$refs['paramFormRef'].resetFields()
      this.paramFormData.paramId = ''
      this.paramFormVisible = false;
      this.getParamLists(this.factorId)
    },
    handleOpenMultiValuesDialog() {
      processApi.getFactorColumn(this.factorId).then(res => {
        console.log("🚀 ~ handleQuickAddRangeColumns ~ res:", res)
        if (res.code == '200') {
          this.multiForm.valueColumns = res.data
          this.multiValuesDialogVisible = true
        }
      })
    },
    handlePreviewMatrixMode() {
      this.previewMultiLists = []
      this.previewColumns = []
      if (this.paramTableData.length > 0) {
        this.paramTableData.forEach(ele => {
          this.previewMultiLists.push({
            paramCode: ele.paramCode,
            paramName: ele.paramName,
            paramDesc: ele.paramDesc,
          })
        })
      }
      if (this.multiForm.valueColumns.length > 0) {
        this.multiForm.valueColumns.forEach(item => {
          this.previewColumns.push({
            columnName: item.columnName,
            columnDesc: item.columnDesc,
          })
        })
      }
      this.title = this.factorName ? this.factorName + ' - 单值二维列表维度预览' : '单值二维列表维度预览';
      this.previewDialogVisible = true
    },
    // 添加列
    handleAddValueColumn() {
      var item = {
        columnName: "",
        columnDesc: "",
      }
      this.multiForm.valueColumns.push(item);
    },
    // 删除列
    handleRemoveValueColumn(row, index) {
      if (row.columnId) {
        processApi.deleteFactorColumn(row.columnId).then(res => {
          console.log("🚀 ~ handleRemoveValueColumn ~ res:", res)
          if (res.code == '200') {
            this.multiForm.valueColumns.splice(index, 1);
          }
        })
      } else {
        this.multiForm.valueColumns.splice(index, 1);
      }
    },
    columnNameRules(index, row) {
      return (this.rules["sheetName"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请填写列名称'));
            }
            callback();
          },
          trigger: "blur",
        },
      ]);
    },
    // 保存配置
    handleSaveMultiValues() {
      if (this.multiForm.valueColumns.length === 0) {
        this.$message.warning("请至少添加一行");
        return;
      }
      this.$refs['multiForm'].validate((valid) => {
        if (valid) {
          this.multiForm.valueColumns.forEach((ele, index) => {
            this.$set(ele, 'factorId', this.factorId)
            this.$set(ele, 'sortIndex', index + 1)
          })
          this.isSaveMultiDisabled = true
          this.isSaveMultiLoading = true
          processApi.addFactorColumn(this.multiForm.valueColumns).then(res => {
            console.log("🚀 ~ handleSaveMultiValues ~ res:", res)
            this.isSaveMultiDisabled = false
            this.isSaveMultiLoading = false
            if (res.code == '200') {
              this.$message.success("多值维度配置保存成功");
              this.onCloseMultiDialog()
            }
          })
        }
      })
    },
    onCloseMultiDialog() {
      this.multiValuesDialogVisible = false;
    },

    // 快速添加范围列
    handleQuickAddRangeColumns() {
      // 重置配置为默认值
      Object.assign(this.rangeConfig, {
        prefix: "",
        startNumber: 1,
        endNumber: 10,
        suffix: "",
      });
      this.setPreviewLists()
      this.rangeColumnsDialogVisible = true;
    },
    // 清空所有列
    handleClearAllColumns() {
      var columnIds = this.multiForm.valueColumns.map(ele => ele.columnId)
      console.log("🚀 ~ handleClearAllColumns ~ columnIds:", columnIds)
      this.$confirm("确定要清空所有列配置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          processApi.deleteFactorColumnList(columnIds).then(res => {
            console.log("🚀 ~ handleClearAllColumns ~ res:", res)
            if (res.code == '200') {
              this.multiForm.valueColumns = [];
              this.$message.success("已清空所有列配置");
            }
          })

        })
        .catch(() => {
          this.$message.info("已取消清空操作");
        });
    },
    applyPreset(presetType) {
      switch (presetType) {
        case "1-10":
          Object.assign(this.rangeConfig, {
            prefix: "",
            startNumber: 1,
            endNumber: 10,
            suffix: "",
          });
          break;
        case "1-20":
          Object.assign(this.rangeConfig, {
            prefix: "",
            startNumber: 1,
            endNumber: 20,
            suffix: "",
          });
          break;
        case "1-50":
          Object.assign(this.rangeConfig, {
            prefix: "",
            startNumber: 1,
            endNumber: 50,
            suffix: "",
          });
          break;
        case "1-100":
          Object.assign(this.rangeConfig, {
            prefix: "",
            startNumber: 1,
            endNumber: 100,
            suffix: "",
          });
          break;
        case "days":
          Object.assign(this.rangeConfig, {
            prefix: "第",
            startNumber: 1,
            endNumber: 31,
            suffix: "天",
            unit: "天",
          });
          break;
        case "batches":
          Object.assign(this.rangeConfig, {
            prefix: "第",
            startNumber: 1,
            endNumber: 20,
            suffix: "批",
            unit: "批",
          });
          break;
      }
      this.setPreviewLists()
      this.$message.success(`已应用预设配置：${presetType}`);
    },
    setPreviewLists() {
      console.log('我31231', this.rangeConfig);
      this.rangePreview = []
      const { prefix, startNumber, endNumber, suffix } = this.rangeConfig;
      if (!startNumber || !endNumber || startNumber > endNumber) {
        this.rangePreview = [];
      } else {
        for (let i = startNumber; i <= endNumber; i++) {
          this.rangePreview.push(`${prefix}${i}${suffix}`);
        }
      }
    },
    numberChange(val) {
      console.log("🚀 ~ numberChange ~ val:", val)
      this.setPreviewLists()
    },
    onCloseRangeConfigDialog() {
      this.rangeConfig = {
        prefix: "",
        startNumber: 1,
        endNumber: 10,
        suffix: "",
      }
      this.rangePreview = [];
      this.rangeColumnsDialogVisible = false;
    },
    // 快速添加范围保存
    handleConfirmAddRangeColumns() {
      if (this.rangePreview.length === 0) {
        this.$message.warning("请检查数字范围配置");
        return;
      }

      if (this.rangePreview.length > 100) {
        this.$message.warning("为了性能考虑,最多只能添加100列");
        return;
      }

      // 生成列配置
      const newColumns = this.rangePreview.map((name, index) => ({
        columnName: name,
        description: `第${this.rangeConfig.startNumber + index}项数据`,
      }));

      // 添加到现有列中
      this.multiForm.valueColumns.push(...newColumns);
      this.$message.success(`成功添加 ${newColumns.length} 列`);
      this.rangeColumnsDialogVisible = false;
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        indicatorCode: "",
        indicatorName: "",
        processId: "",
        status: "",
      }
      this.queryData()
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}
</script>
  